import { createAction } from "@reduxjs/toolkit";

export const clearIntegrationsState = createAction("integrations/clearState");

export const finishLoadingIntegrations = createAction<{
  integrationsLoader: boolean;
}>("kpi/finishLoadingIntegrations");
